import { createSelector } from 'reselect';
import { get } from 'lodash/fp';
import loadableLineupsSelector from './loadableLineupsSelector';

function filterSelectedLineupIds(lineups, selectedLineupIds) {
  return selectedLineupIds.filter(selectedId => lineups.find(({ id }) => id === selectedId));
}

const selectedLineupIdsSelector = createSelector(
  loadableLineupsSelector,
  get('myTeams.selectedLineupIds'),
  filterSelectedLineupIds
);

export default selectedLineupIdsSelector;
